import { actionConst } from '../constants/address.constants';
import { requestListConstants } from '../containers/Requests/request-list.constants';
import moment from 'moment';
import { requestsConstants } from '../containers/Requests/requests.constants';
import { authHeader, authUploadHeader } from '../helpers/auth-header';
import { client } from './';
import { requestsActions } from '../containers/Requests/requests.actions';

const url = '/Request';

const actions = {
	openAddressModal,
	closeAddressModal,
	openPossWarrantyModal,
	closePossWarrantyModal,
	postAddress,
}

/*function postCalendarEvent(data) {
	let rurl = url + '/add_task';
	return client.post(rurl, data, { headers: authHeader() })
}*/

function postAddress(value) {
	return (dispatch, getState) => {		
		const curl = url + '/set_address/' + value.request;
		const v = {
			addressId: value.addressId,
			executorId: value.executerId,
			masterId: value.masterId,
			serviceId: value.typeId,
		}
		client.put(curl, v, { headers: authHeader() }).then(response => {

			/*if (value.addEventToCalendar) {
				new Promise((resolve, reject) => {
					if (value.executeTimeEnd.hour() == 0 && value.executeTimeEnd.minute() == 0) {
						value.executeTimeEnd.set({ 'hour': 23, 'minute': 59, 'second': 59 })
					}
					const calendarEvent = {
						requestId: value.request,
						workerId: value.executerId,
						fromDate: value.eventDate.format('YYYY-MM-DD' + value.executeTimeStart.format(' HH:mm:00'),
						toDate: value.eventDate.format('YYYY-MM-DD' + value.executeTimeEnd.format(' HH:mm:SS')
					}
					postCalendarEvent(calendarEvent)
						.then(response => {
							console.log(response);
							resolve()
						})
						.catch(function (error) {
							console.log(error);
							dispatch({
								type: requestsConstants.POST_ERROR,
								payload: error
							})
						})
				}).then(() => {
					//dispatch(requestsActions.fetchRequests(nr));
				})
			}*/

			const r = getState().requestsStore.requests.slice()
			const i = r.findIndex(el => '' + el.id == value.request)
			const rurl = url + '?requestId=' + value.request
			dispatch({
				type: requestsConstants.SET_REQUEST_ADDRESS,
				payload: client.get(rurl, { headers: authHeader() }).then(response =>
					new Promise(resolve => {
						r[i] = response.data && response.data[0];
						resolve({ data: r })
					}
					)
				)
					.catch(function (error) {
						console.log(error);
						dispatch({
							type: requestsConstants.POST_ERROR,
							payload: error
						})
					})
			})
		})
			.catch(function (error) {
				console.log(error);
				dispatch({
					type: requestsConstants.POST_ERROR,
					payload: error
				})
			})
	}
}

function openAddressModal( record ) {
	return dispatch => {
		dispatch({
			type: actionConst.OPEN_ADDRESS_MODAL,
			payload: record
		})
	}
}

function openPossWarrantyModal( record ) {
	return dispatch => {
		dispatch({
			type: actionConst.OPEN_POSS_WARRANTY_MODAL,
			payload: record
		})
	}
}

function closeAddressModal() {
	return dispatch => {
		dispatch({
			type: actionConst.CLOSE_ADDRESS_MODAL
		})
	}
}

function closePossWarrantyModal() {
	return dispatch => {
		dispatch({
			type: actionConst.CLOSE_POSS_WARRANTY_MODAL
		})
	}
}

export default actions;